const state = {
  isFromPlugin: 0,
}

const mutations = {
  CHANGE_STATUS: (state,data) => {
    state.isFromPlugin = data
  }
}

const actions = {
   setStatus({commit},data) {
    commit('CHANGE_STATUS',data)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/plugin.js